/**
 * @generated SignedSource<<901c8ed28bcab93831445f56da3c9cd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectStatusColumnDropdown_columns$data = ReadonlyArray<{
  readonly node: {
    readonly order: number | null;
    readonly name: string | null;
    readonly id: string;
    readonly projectGroupStatusColumnId: number | null;
  } | null;
  readonly " $fragmentType": "ProjectStatusColumnDropdown_columns";
}>;
export type ProjectStatusColumnDropdown_columns$key = ReadonlyArray<{
  readonly " $data"?: ProjectStatusColumnDropdown_columns$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectStatusColumnDropdown_columns">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ProjectStatusColumnDropdown_columns",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupStatusColumnId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StatusColumnV2TypeEdge",
  "abstractKey": null
};

(node as any).hash = "9e4e206e9751fabce9e60e75f24080c7";

export default node;
